
export const showIaAlert = (type, onSetIaAlert) => {
    const payload =
        type === 'success'
            ? {
                variant: 'success',
                title: 'Completamos los datos automáticamente',
                description: 'Por favor, verificalos antes de continuar.',
                titleStyle: 'text-left',
                descriptionStyle: 'text-left',
                iconStyle: 'text-success-20',
            }
            : {
                variant: 'warning',
                title: 'No pudimos completar los datos automáticamente',
                description: 'Intentá de nuevo o completá los campos manualmente.',
                titleStyle: 'text-left',
                descriptionStyle: 'text-left',
                iconStyle: 'text-warning-10',
            };

    onSetIaAlert(payload);
};